<span>
  {copyrightNotice}
</span>

<style lang="less">
  @import (reference) '../../../less/variables';
  @import (reference) '../../../less/mixins';

  span {
    flex-shrink: 0;
    padding: 1em 0;
    margin: 0 @masthead-gutter-width 0 auto;

    .footer-text-small();
    color: @masthead-gray-50;
  }
</style>

<script>
  export let copyrightNotice;
</script>
